import { render, staticRenderFns } from "./tbcb.vue?vue&type=template&id=4614ca33&"
import script from "./tbcb.vue?vue&type=script&lang=js&"
export * from "./tbcb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports